/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import abstractCaseTranslations from "./abstractCaseTranslations";
import abstractLitigationCaseTranslations from "./abstractLitigationCaseTranslations";
import abstractAdministrativeLitigationCaseTranslations from "./abstractAdministrativeLitigationCaseTranslations";

const civilServiceLawTranslations = {
  ...abstractCaseTranslations,
  ...abstractLitigationCaseTranslations,
  ...abstractAdministrativeLitigationCaseTranslations,
  label: "Beamtenrecht",
  finalClientDescriptionAndObjectives: {
    label: "Beschreibung des Anliegens",
  },
  personnelNumber: {
    question: "Wie lautet Ihre Personalnummer?",
    label: "Personalnummer",
    helperText:
      "Ihre Personalnummer finden Sie auf dem Kopf Ihrer Bezügemitteilung unter 'Pers-Nr.' oder 'Personalnummer'. Bitte übernehmen Sie die Nummer ohne Leerzeichen.",
    validators: {
      required: "Bitte geben Sie Ihre Personalnummer an.",
    },
  },
  civilServiceStatus: {
    question: "Wie ist Ihr aktueller Dienststatus?",
    label: "Dienststatus",
    options: {
      active: {
        label: "Aktiv (Beamter auf Lebenszeit, Beamter auf Probe, Beamter auf Widerruf)",
      },
      retired: {
        label: "Ruhestand (Pensionär)",
      },
    },
    validators: {
      required: "Bitte wählen Sie eine der angezeigten Antworten aus.",
    },
  },
  authorityAddress: {
    ...abstractAdministrativeLitigationCaseTranslations.authorityAddress,
    headlineMoneyAndRefund: "Anschrift der Behörde",
    labelMoneyAndRefund: "Anschrift der Behörde",
    headlineCareerAndEmployment: "Anschrift der Dienststelle",
    labelCareerAndEmployment: "Anschrift der Dienststelle",
  },
  objectiveClient: {
    question: "Worum geht es bei Ihrem Anliegen?",
    label: "Anliegen Beamter",
    options: {
      moneyAndRefund: {
        label: "Geld & Erstattung",
      },
      careerAndEmployment: {
        label: "Karriere & Dienstverhältnis",
      },
    },
    validators: {
      required: "Bitte wählen Sie eine der angezeigten Antworten aus.",
    },
  },
  authorityName: {
    ...abstractAdministrativeLitigationCaseTranslations.authorityName,
    labelMoneyAndRefund: "Name Behörde",
    questionMoneyAndRefund: "Wie lautet die Behörde, die für Ihre Bezüge bzw. Beihilfen verantwortlich ist?",
    placeholderMoneyAndRefund: "Landesamt für Besoldung (LBV), Bundesverwaltungsamt (BVA), LfF oder OFD",
    helperTextMoneyAndRefund:
      "Bitte geben Sie die Behörde auf dem Briefkopf Ihrer letzten Bezügemitteilung (Gehaltsabrechnung) oder eines aktuellen Bescheids an.",
    labelCareerAndEmployment: "Name Dienststelle",
    questionCareerAndEmployment: "Welche Dienststelle führt Ihre Personalakte?",
    placeholderCareerAndEmployment: "Bezirksregierung Köln, Polizeipräsidium, Schulamt, Ministerium",
    helperTextCareerAndEmployment: "Meist ist dies nicht Ihre lokale Dienststelle (z. B. Schule oder Wache), sondern die übergeordnete Behörde.",
  },
  authorityTelephone: {
    ...abstractAdministrativeLitigationCaseTranslations.authorityTelephone,
    labelMoneyAndRefund: "Telefon Behörde",
    labelCareerAndEmployment: "Telefon Dienststelle",
  },
  workLocationPostalCode: {
    question: "Wie lautet die PLZ Ihres dienstlichen Wohnsitzes?",
    label: "Dienstlicher Wohnsitz PLZ",
    helperText:
      "Bitte geben Sie die Postleitzahl des Ortes an, an dem Sie Ihren täglichen Dienst verrichten (z. B. die Anschrift Ihrer Schule, Polizeiwache oder des Amtes)",
    validators: {
      required: "Bitte geben Sie die PLZ Ihres dienstlichen Wohnsitzes an.",
    },
  },
};

export default civilServiceLawTranslations;
